import SwipeDeck from './SwipeDeck';

export default SwipeDeck;
